module.exports = (__webpack_require__(4))(184);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/body/ItemView.js from dll-reference girder_plugin_histomicsui
// module id = 17
// module chunks = 0